import { z } from 'zod';
export const UuidParamSchema = z.object({
    id: z.string().uuid()
});
//# sourceMappingURL=uuidParamSchema.js.map